import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"
import _imports_0 from './assets/logo.png'


const _hoisted_1 = {
  class: "navbar",
  role: "navigation",
  "aria-label": "main navigation"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "navbar-brand" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "navbar-item",
    href: "/"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      alt: "JPSO logo",
      src: _imports_0
    })
  ]),
  /*#__PURE__*/_createElementVNode("a", {
    role: "button",
    class: "navbar-burger",
    "aria-label": "menu",
    "aria-expanded": "false",
    "data-target": "navbarBasicExample"
  }, [
    /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }),
    /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }),
    /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" })
  ])
], -1)
const _hoisted_3 = { class: "navbar-menu" }
const _hoisted_4 = { class: "navbar-end" }
const _hoisted_5 = {
  key: 2,
  class: "navbar-item has-dropdown is-hoverable"
}
const _hoisted_6 = { class: "navbar-link has-text-weight-bold" }
const _hoisted_7 = { class: "navbar-dropdown" }
const _hoisted_8 = { class: "navbar-item" }
const _hoisted_9 = { class: "buttons" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { id: "google-translate-container" }, [
  /*#__PURE__*/_createElementVNode("div", { id: "google_translate_element" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_o_icon = _resolveComponent("o-icon")!
  const _component_o_loading = _resolveComponent("o-loading")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_o_loading, {
      active: _ctx.isLogoutPageLoading,
      "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isLogoutPageLoading) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_o_icon, {
          pack: "fa",
          icon: "spinner",
          size: "large",
          spin: "",
          variant: "primary"
        })
      ]),
      _: 1
    }, 8, ["active"]),
    _createElementVNode("nav", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            class: "navbar-item has-text-weight-bold",
            to: "/"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Home ")
            ]),
            _: 1
          }),
          (!_ctx.isUserLoggedIn)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                class: "navbar-item has-text-weight-bold",
                to: "/create-account"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Create account ")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isUserLoggedIn)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                to: "/past-payment",
                class: "navbar-item has-text-weight-bold"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Past Payments ")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isUserLoggedIn)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("a", _hoisted_6, _toDisplayString(_ctx.computedUserId), 1),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_router_link, {
                    to: "/account-managment",
                    class: "navbar-item"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Account Management ")
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              (!_ctx.isUserLoggedIn)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    class: "button is-info has-text-weight-bold",
                    to: "/login"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Log in ")
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    class: "button is-info has-text-weight-bold",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.logout()))
                  }, " Log out "))
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_router_view),
    _hoisted_10
  ], 64))
}